import { createApp } from '@backstage/frontend-defaults';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import { navModule } from './modules/nav';
import { iconsModule } from './modules/icons';
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { ThemeBlueprint } from '@backstage/plugin-app-react';
import { UnifiedThemeProvider } from '@backstage/theme';
import { autheliaAuthApi, customSignInPage } from './auth';
import argoTerminalPlugin from './components/argoTerminal/plugin';
import kubeSecretsPlugin from './components/kubeSecrets/plugin';
import odooEnvironmentsPlugin, {
  odooBranchPagePlugin,
  odooEnvironmentsTranslationModule,
} from './components/odooEnvironments/plugin';
import { i18nModule } from '@waadoo/backstage-i18n';
import { lightTheme, darkTheme } from './themes';
import './styles.css'; // Backstage UI (BUI) theme

const autheliaAuthModule = createFrontendModule({
  pluginId: 'app',
  extensions: [autheliaAuthApi, customSignInPage],
});

const lightThemeExtension = ThemeBlueprint.make({
  name: 'light',
  params: {
    theme: {
      id: 'light',
      title: 'Light theme',
      variant: 'light',
      Provider: ({ children }) => (
        <UnifiedThemeProvider theme={lightTheme} children={children} />
      ),
    },
  },
});

const darkThemeExtension = ThemeBlueprint.make({
  name: 'dark',
  params: {
    theme: {
      id: 'dark',
      title: 'Dark theme',
      variant: 'dark',
      Provider: ({ children }) => (
        <UnifiedThemeProvider theme={darkTheme} children={children} />
      ),
    },
  },
});

const themeModule = createFrontendModule({
  pluginId: 'app',
  extensions: [lightThemeExtension, darkThemeExtension],
});

export default createApp({
  features: [
    catalogPlugin,
    navModule,
    iconsModule,
    autheliaAuthModule,
    argoTerminalPlugin,
    kubeSecretsPlugin,
    odooEnvironmentsPlugin,
    odooEnvironmentsTranslationModule,
    odooBranchPagePlugin,
    i18nModule,
    themeModule,
  ],
});
